import { ActivePaymentMethod } from "../../../types/ExchangeInterface";
import { usePresale } from "../../../utils/hooks/presale-manager/read/usePresale";
import { useUSDTBalance } from "../../../utils/hooks/usdt-manager/read/useUSDTBalance";
import { useEffect } from "react";
import exchangeInterfaceStore from "../../../stores/ExchangeInterfaceStore";
import {
  ESTIMATED_TRANSACTION_FEES,
  PAYMENT_METHODS,
  PRESALE_ID,
  STATUS,
} from "../../../utils/constants";
import { useAllowance } from "../../../utils/hooks/usdt-manager/read/useAllowance";

import { useBNBBalance } from "../../../utils/hooks/presale-manager/read/useBNBBalance";
import { observer } from "mobx-react";
import Inputs from "./Inputs";
import { resetInputValues } from "../../../utils/helpers";
import BuyButton from "./BuyButton";
import { formatEther } from "viem";
import ErrorText from "./ErrorText";

const Buy = () => {
  const usdtBalance = useUSDTBalance()?.usdtBalance!;
  const allowance = useAllowance()?.allowance!;
  const bnbBalance = useBNBBalance()?.bnbBalance!;
  const presale = usePresale(PRESALE_ID)?.data!;

  const {
    activePaymentMethod,
    inputsValues,
    setActivePaymentMethod,
    setStatus,
    statuses,
  } = exchangeInterfaceStore;

  const { baseCoinsToPay, pepeCoinsToReceive } = inputsValues;

  useEffect(() => {
    if (
      !presale ||
      !bnbBalance ||
      (!allowance && allowance < 0) ||
      (!usdtBalance && usdtBalance < 0)
    )
      return;

    const formattedBNBBalance = Number(formatEther(bnbBalance.value));
    if (presale.endTime < new Date())
      return setStatus(STATUS.PRESALE_ENDED, true);

    if (Number(pepeCoinsToReceive) >= 0 && Number(pepeCoinsToReceive) < 1666.66 ) {
      return setStatus(STATUS.BELOW_MINIMUM, true);
    }

    if (
      activePaymentMethod === PAYMENT_METHODS.BNB &&
      formattedBNBBalance < Number(baseCoinsToPay) + ESTIMATED_TRANSACTION_FEES && !statuses.BELOW_MINIMUM
    ) {
      return setStatus(STATUS.NOT_ENOUGH_BALANCE, true);
    }

    if (
      activePaymentMethod === PAYMENT_METHODS.USDT &&
      usdtBalance < Number(baseCoinsToPay) && !statuses.BELOW_MINIMUM
    )
      return setStatus(STATUS.NOT_ENOUGH_BALANCE, true);


    if (formattedBNBBalance < ESTIMATED_TRANSACTION_FEES && !statuses.BELOW_MINIMUM)
      return setStatus(STATUS.NOT_ENOUGH_FEES, true);
    
    if (
      activePaymentMethod === PAYMENT_METHODS.USDT &&
      Number(baseCoinsToPay) > allowance && !statuses.BELOW_MINIMUM
    )
      return setStatus(STATUS.NOT_ENOUGH_ALLOWANCE, true);

    if (presale.tokensToSell < Number(pepeCoinsToReceive)) {
      return setStatus(STATUS.NOT_ENOUGH_TOKENS, true);
    }

    setStatus(STATUS.NOT_ENOUGH_FEES, false);
    setStatus(STATUS.NOT_ENOUGH_ALLOWANCE, false);
    setStatus(STATUS.NOT_ENOUGH_BALANCE, false);
    setStatus(STATUS.PRESALE_ENDED, false);
    setStatus(STATUS.NOT_ENOUGH_TOKENS, false);
    setStatus(STATUS.BELOW_MINIMUM, false);
  }, [
    bnbBalance,
    allowance,
    usdtBalance,
    baseCoinsToPay,
    statuses,
    activePaymentMethod,
    setStatus,
    pepeCoinsToReceive,
    presale,
  ]);

  return (
    <div className="flex flex-col justify-center gap-y-6">
      {/*Payment methods*/}
      <div className="mt-4 grid grid-cols-2  place-items-center">
        {["BNB", "USDT"].map((tokenName) => (
          <button
            key={tokenName}
            onClick={() => {
              setActivePaymentMethod(tokenName as ActivePaymentMethod);
              if (activePaymentMethod === tokenName) return;
              resetInputValues();
            }}
            className={`h-12 w-28 gap-x-2 border rounded-xl border-white font-bold text-[#fff] flex justify-center items-center uppercase ${
              activePaymentMethod === tokenName &&
              " shadow-inner shadow-black bg-lime-500"
            }`}
          >
            <img
              className="w-6 h-6"
              src={`/assets/icons/${tokenName.toLocaleLowerCase()}.svg`}
              alt={`${tokenName}_LOGO`}
            />
            {tokenName}
          </button>
        ))}
      </div>
      <p className="dashTitle tracking-wide font-semibold">
        1 $PEPE3D = ${0.003}
      </p>
      {/* Inputs */}
      <div className="grid grid-cols-2 gap-4">
        <Inputs />
      </div>
      {typeof usdtBalance === "number" && bnbBalance && (
        <p className="dashTitle">
          {activePaymentMethod} balance{" "}
          {activePaymentMethod === PAYMENT_METHODS.USDT
            ? usdtBalance
            : Number(formatEther(bnbBalance.value)).toFixed(8)}
        </p>
      )}
      {/*Texts*/}
      <ErrorText />
      {/*BUY NOW BUTTON */}
      <hr className="border-gray-200/90" />
      <BuyButton />
    </div>
  );
};

export default observer(Buy);
